import type {
  FacilityFormModel,
  FacilitySection,
} from "Components/Shared/Merchant/Facilities/schema";
import type { PhoneNumber } from "Infrastructure/Api/Api";

export type FacilityFormVariant = "complete" | "minimal";

// Mirrors the server-side limits in UploadMerchantFacilityPhotosCommandHandler.
export const FACILITY_PHOTO_MAX_SIZE_MB = 10;
export const FACILITY_PHOTO_MAX_SIZE_BYTES =
  FACILITY_PHOTO_MAX_SIZE_MB * 1024 * 1024;
export const FACILITY_PHOTO_ACCEPTED_TYPES: ReadonlyArray<string> = [
  "image/jpeg",
  "image/png",
  "image/webp",
];

export type ContactSource = {
  responsiblePerson: string;
  phone: PhoneNumber;
  email?: string | null;
};

export const SECTION_ORDER: ReadonlyArray<FacilitySection> = [
  "basicInformation",
  "contact",
  "publicFacilityInfo",
  "address",
  "turnover",
  "terminals",
  "photos",
];

export const SECTION_FIELDS_MAP: Record<
  FacilitySection,
  ReadonlyArray<keyof FacilityFormModel>
> = {
  basicInformation: ["name", "providedServices"],
  contact: ["responsiblePerson", "phone", "email"],
  publicFacilityInfo: ["isPublic", "categoryCodes", "description", "hours"],
  address: ["address"],
  turnover: [
    "yearlyTurnover",
    "realCardTurnover",
    "averageTransactionValue",
    "estimatedTurnover",
  ],
  terminals: ["terminalCount", "softPosCount"],
  photos: [],
};
